module.exports = __webpack_public_path__ + "assets/img/hill-5.9dd47bd9.png";